module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image14n.38d4ee49.jpg";